import React from 'react';
import ParametersCheckListComponent from '../../components/Filters/parametersCheckList';

class ParametersCheckList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            value: 'Ninguno',
            checkboxes: [],
            checkAll: false,
        }
        this.setOpen = this.setOpen.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClickListItem = this.handleClickListItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleChangeAll = this.handleChangeAll.bind(this);
    }

/*
    componentDidMount() {
        const { data } = this.props;
        this.setState({ checkAll: false });
        const checkboxes = [];
        for (var i = 0; i < data.length; i++) {
            var checkboxItem = {};
            checkboxItem = {
                name: data[i].name,
                id: data[i].id,
                checked: false
            }
            checkboxes.push(checkboxItem);
        }
        this.setState({ checkboxes: checkboxes });
    };

    */

    componentDidMount() {
        this.setInitialState();
    };

    /**
     * Asigna valor inicial para checkboxes.
    */
    setInitialState(){
        const { data } = this.props;
        this.setState({ checkAll: false });
        const checkboxes = [];
        for (var i = 0; i < data.length; i++) {
            var checkboxItem = {};
            checkboxItem = {
                name: data[i].name,
                id: data[i].id,
                checked: false
            }
            checkboxes.push(checkboxItem);
        }
        this.setState({ checkboxes: checkboxes, value: "Ninguno" });
    }

    /**
     * Abre y cierra modal de selección de parámetros.
     * @param {Boolean} value - Valor a asignar al estado de apertura.
    */
    setOpen(value) {
        this.setState({ open: value })
    };

    /**
     * Asigna valor booleano a campos checkeados.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un checkbox.
    */
    handleChange(e) {
        const { checkboxes } = this.state;
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].id === e.target.id) {
                checkboxes[i].checked = e.target.checked;
            }
        }
        this.setState({ checkboxes: checkboxes });
    };

     /**
     * Asigna el mismo valor booleano a todos los checkbox.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre el checkbox "Todos".
    */
    handleChangeAll(e) {
        this.setState({ checkAll: e.target.checked })
        const { checkboxes, checkCampus } = this.state;
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = e.target.checked;
        }
        this.setState({ checkboxes: checkboxes })
    }

    /**
     * Asigna texto secundario con parámetros seleccionados.
     * @param {String} e - Texto con parametros seleccionados.
    */
    setValue(value) {
        this.setState({ value: value })
    };

    /**
     * Abre modal con tipos de salas al hacer clic sobre item de parámetros a graficar en Filtros.
    */
    handleClickListItem() {
        this.setOpen(true);
    };

    /**
     * Cierra modal de selección de parámetros a graficar y asigna texto secundario con datos seleccionadas.
     * @param {String} newValue - Texto con parámetros seleccionados.
    */
    handleClose(newValue) {
        this.setOpen(false);

        if (newValue) {
            this.setValue(newValue);
        }
    };

    /**
     * Crea y asigna mensaje de datos seleccionados en el filtro al hacer clic en "Ok" en el modal.
    */
    handleOk() {
        //crear mensaje filtro y agregar a array de mensaje de filtros (en chartview)
        const { id, name, updateFiltersMessage } = this.props;
        const { checkboxes } = this.state;
        var parametersArray = [];
        var parameters = '';
        var checkedValues = []
        checkboxes.map(parameter => {
            if (parameter.checked) {
                parametersArray.push(
                    '<parameter>',
                    '<id>',
                    parameter.id,
                    '</id>',
                    '<name>',
                    parameter.name,
                    '</name>',
                    '</parameter>'
                );
                checkedValues.push(parameter.name)
            }
        });
        parameters = parametersArray.join('');
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }

        updateFiltersMessage(message);
        const values = checkedValues.join(", ")
        var secondaryText = checkedValues.length === 0 ? 'Ninguno' : values;
        this.handleClose(secondaryText);
    };

    render() {
        const { open, value, checkboxes,checkAll } = this.state;
        const { required, height } = this.props;
        return (
            <ParametersCheckListComponent
                height={height}
                open={open}
                value={value}
                required={required}
                checkboxes = {checkboxes}
                checkAll={checkAll}
                handleClickListItem={this.handleClickListItem}
                handleChange={this.handleChange}
                handleOk={this.handleOk}
                handleChangeAll={this.handleChangeAll}

            />
        )
    }
}

export default ParametersCheckList;